import axios from 'axios';
import { handleResponse } from './HelperService';


const getSO = (id, onSuccess, onError) => {
    const response = axios.get('v1/e-statement/salesorder/' + id);
    return handleResponse(response, onSuccess, onError);
};
const getPO = (id, onSuccess, onError) => {
    const response = axios.get('v1/e-statement/purchaseorder/' + id);
    return handleResponse(response, onSuccess, onError);
};
const getDelivery = (id, onSuccess, onError) => {
    const response = axios.get('v1/e-statement/delivery/' + id);
    return handleResponse(response, onSuccess, onError);
};
const getTransfer = (id, onSuccess, onError) => {
    const response = axios.get('v1/e-statement/inventory-receipt/' + id);
    return handleResponse(response, onSuccess, onError);
};

export {
    getSO, 
    getPO,
    getDelivery,
    getTransfer
};